import React from 'react';
import { Link } from 'react-router-dom';

function Help() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Platform Help Desk: Navigating the Independent Medical Tourism Directory
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', margin: 0 }}>
          Need assistance tracking down relevant treatment profiles or formatting your documentation files? Follow the streamlined research protocols below to maximize the search tools hosted on <strong>Medical Trip World</strong>.
        </p>
      </header>

      {/* NAV MANUAL */}
      <section style={{ marginTop: '30px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.4rem)' }}>
          How to Navigate the Cross-Border Search Portal
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '15px', color: '#444', lineHeight: '1.7', fontSize: '0.95rem' }}>
          <p style={{ margin: 0 }}><strong>1. Locate Specialty Fields:</strong> Expand the upper multi-specialty dropdown matrix to review historical data benchmarks across cardiology, oncological staging, and robotic orthopedic reconstructions.</p>
          <p style={{ margin: 0 }}><strong>2. Access Comparative Estimators:</strong> Query our cost estimation tables to track public price parameters across prominent private hospital clusters in New Delhi, Gurgaon, and Noida.</p>
          <p style={{ margin: 0 }}><strong>3. Use Document Organizers:</strong> Download our open processing manuals to compile your radiological DICOM files, daily drug lists, and passport scans before connecting with an international patient support desk.</p>
        </div>
      </section>

      {/* CRITICAL WARNING RIGIDLY CONTEXTUAL */}
      <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '4px', marginTop: '35px', borderLeft: '4px solid #ff9f1c', boxSizing: 'border-box' }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: '6px' }}>⚠️ Critical Emergency Communication Notice</h4>
        <p style={{ margin: '0', fontSize: '0.95rem', color: '#333', lineHeight: '1.6' }}>
          Medical Trip World operates strictly as an independent informational directory and research portal. We do not staff live emergency response departments, arrange urgent ambulance transportation, manage hospital triage operations, or provide clinical medical services. If you are experiencing an acute health crisis or life-threatening event, please reach out to local emergency operators or your healthcare provider immediately.
        </p>
      </div>

    </article>
  );
}

export default Help;